import { Component, OnInit } from '@angular/core';
import { IntUser, SharedDataService } from 'ngx-paf-common';

@Component({
  selector: 'app-locked-user',
  templateUrl: './locked-user.component.html',
  styleUrls: ['./locked-user.component.scss']
})
export class LockedUserComponent implements OnInit {

  constructor(
    public sharedDataSvc: SharedDataService) { }

  ngOnInit(): void {
    this.sharedDataSvc.loggedIntUserChange
    .subscribe((intUser:IntUser)=>{
      if (intUser!= null){
        this.sharedDataSvc.redirectToDefaultScreen(true);
      }
    })
  }

}
